import { styled } from '@mui/material';
import MuiIconButton, {
  IconButtonProps as MuiIconButtonProps,
} from '@mui/material/IconButton';
import type { Ref } from 'react';

const StyledIconButton = styled(MuiIconButton, {
  name: 'IconButton',
  shouldForwardProp: (propName) => propName !== 'variant',
})<IconButtonProps>(({ theme, variant }) => ({
  padding: theme.spacing(1),
  ...(variant === 'outlined' && {
    padding: subPixels(theme.spacing(1), 1),
    border: '1px solid',
    borderColor: theme.palette.action.selected,
  }),
  ...(variant === 'filled' && {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  }),
}));

function subPixels(str: string, val: number) {
  const num = Number.parseInt(str.replace('px', ''));
  return `${num - val}px`;
}

interface IconButtonProps extends MuiIconButtonProps {
  variant?: 'icon' | 'outlined' | 'filled';
  ref?: Ref<HTMLButtonElement>;
}

const IconButton = ({
  variant = 'icon',
  classes: _classes,
  ref,
  ...rest
}: IconButtonProps) => {
  return <StyledIconButton {...rest} variant={variant} ref={ref} />;
};

export default IconButton;
